import Image from "next/image";
import React from "react";

const RegionShowChildButton = ({ checked, isExpanded, onClick }) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Image
        src={checked ? "/icons/orangeArrow.svg" : "/icons/filterArrow.svg"}
        width={16}
        height={16}
        alt="arrow"
        className={isExpanded ? "rotate-180" : ""}
      />
    </button>
  );
};

export default RegionShowChildButton;
